import React from "react";
import Navbar from "../navbar/Navbar";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./videofile.css";

const useStyles = makeStyles(theme => ({
  root: { width: "100%" },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

const CNS_main_topic = [
  { url: "https://www.youtube.com/embed/Fyr9rUWhhTM" }, //  CHINESE REMAINDER THEOREM
  { url: "https://www.youtube.com/embed/_zq4qTc9Jmg" }, //  ATTACKS
  { url: "https://www.youtube.com/embed/eIoit6XCC1o" }, //  RSA Cryptosystem Algorithm (Public Key Algorithm)
  { url: "https://www.youtube.com/embed/bZBVbvNjxKY" }, //Substitution and transposition techniques
  { url: "https://www.youtube.com/embed/y6e70OKHg7c" }, //DIGITAL SIGNATURE
  { url: "https://www.youtube.com/embed/Xi-oisdGr_g" }, //FIREWALLS
  { url: "https://www.youtube.com/embed/Fr2fQlQIokY" }, //Authentication
  { url: "https://www.youtube.com/embed/zLKT4-uRGw4" }, //Diffie-Hellman Key Exchange
  { url: "https://www.youtube.com/embed/p6w9RZ5PNho" }, //Kerberos
  { url: "https://www.youtube.com/embed/V7ibcCclsGI" } //Needham-Schroeder Protocol.
];
const CNS_extra_topics = [
  { url: "https://www.youtube.com/embed/rnXhH5dvnCo" }, //  CHINESE REMAINDER THEOREM
  { url: "https://www.youtube.com/embed/ktb7aouxpRw" }, //  ATTACKS
  { url: "https://www.youtube.com/embed/rlJTMUBXhKE" }, //  RSA Cryptosystem Algorithm (Public Key Algorithm)
  { url: "https://www.youtube.com/embed/bgNvfDUZMtM" }, //Substitution and transposition techniques
  { url: "https://www.youtube.com/embed/jXw-CXYT01M" }, //DIGITAL SIGNATURE
  { url: "https://www.youtube.com/embed/G_qtQgRmiWk" }, //Authentication
  { url: "https://www.youtube.com/embed/zLNug0LrFiU" }, //Diffie-Hellman Key Exchange
  { url: "https://www.youtube.com/embed/EWDKPrZfq_M" } //Kerberos
];

const CG_main_topic = [
  { url: "https://www.youtube.com/embed/rf0LmaZIGXA" }, //  CG BASICS
  { url: "https://www.youtube.com/embed/W5P8GlaEOSI" }, //  DDA LINE DRAWING
  { url: "https://www.youtube.com/embed/RGB-wlatStc" } //   Bresenham's
];
const CG_extra_topics = [
  { url: "https://www.youtube.com/embed/2PJx4ivfAZw" }, //  DDA LINE DRAWING
  { url: "https://www.youtube.com/embed/ktb7aouxpRw" } //  ATTACKS
];

const OR_main_topic = [
  { url: "https://www.youtube.com/embed/ItOuvM2KmD4" }, //  transportation problem
  { url: "https://www.youtube.com/embed/KVGEXbmvsfk" }, //  Unbalanced Transportation Problem
  { url: "https://www.youtube.com/embed/M8POtpPtQZc" }, //  LPP using||SIMPLEX METHOD||
  { url: "https://www.youtube.com/embed/SNc9NGCJmns" }, //  LPP using SIMPLEX METHOD [MINIMIZATION with 3 VARIABLES]
  { url: "https://www.youtube.com/embed/KLHWtBpPbEc" }, //  Lpp using [DUAL SIMPLEX METHOD - Minimization]
  { url: "https://www.youtube.com/embed/MZ843Vvia0A" }, //  LPP using [Big M Method]

  { url: "https://www.youtube.com/embed/vUMGvpsb8dc" }, //  CPM - Critical Path Method|
  { url: "https://www.youtube.com/embed/WrAf6zdteXI" }, //  PERT - Project Evaluation Review and Technique
  { url: "https://www.youtube.com/embed/rrfFTdO2Z7I" }, //  Steps to solve - Hungarian Method
  { url: "https://www.youtube.com/embed/k3I2eThAErc" }, //  Travelling Salesman proble
  { url: "https://www.youtube.com/embed/fSuqTgnCVRg" }, //  Game theory #1||Pure & Mixed Strategy
  { url: "https://www.youtube.com/embed/YJvbxAvxkDc" }, //  Game Theory #2||Dominance Property|

];
const OR_extra_topics = [
  { url: "https://www.youtube.com/embed/O6QO3J_85as" }, //  LPP - Graphical Method [#2] [Minimization & Maximization with 3 Constraints]
  { url: "https://www.youtube.com/embed/-w2z3MVTcQA" }, //  Transportation problem [ MODI method - U V method]
  { url: "https://www.youtube.com/embed/zN4AE1YjE2I" }, //  Degeneracy in Transportation Problem
  { url: "https://www.youtube.com/embed/KUskbAasVCY" }, //   Game Theory [#3]Graphical Method
  { url: "https://www.youtube.com/embed/8IRrgDoV8Eo" }, //  LPP - Graphical method
];

const SsCd_main_topic = [
  { url: "https://www.youtube.com/embed/Qkwj65l_96I" }, //  Compiler Design lecture 1-- Introduction and various phases of compiler
  { url: "https://www.youtube.com/embed/WccZQSERfCM" }, //  Compiler Design Lecture2 -- Introduction to lexical analyser and Grammars
  { url: "https://www.youtube.com/embed/9vmhcBpZDcE" }, //  Compiler Design Lecture 3 -- Ambiguous grammars and making them unambiguous
  { url: "https://www.youtube.com/embed/3_VCoBfrt9c" }, //  Compiler Design Lecture 4 -- Elimination of left recursion and left factoring the grammars
  { url: "https://www.youtube.com/embed/N9UuAPU6DAg" }, //  Compiler Design Lecture 5 -- Introduction to parsers and LL(1) parsing
  { url: "https://www.youtube.com/embed/_uSlP91jmTM" }, //  Compiler Design Lecture 6 -- Examples on how to find first and follow in LL(1)
  { url: "https://www.youtube.com/embed/R1ZlWEZWMKk" }, //  Compiler Design Lecture 7 -- Construction of LL(1) parsing table
  { url: "https://www.youtube.com/embed/SH5F-rwWEog" }, //  Compiler Design Lecture 8 -- Recursive descent parser
  { url: "https://www.youtube.com/embed/n5UWAaw_byw" }, //  Compiler Design Lecture 9 -- Operator grammar and Operator precedence parser
  { url: "https://www.youtube.com/embed/APJ_Eh60Qwo" } //   Compiler Design Lecture 10 -- LR parsing, LR(0) items and LR(0) parsing table
];
const SsCd_extra_topics = [
  { url: "https://www.youtube.com/embed/0kiTNN2kHyY" }, // Compiler Design Lecture 11 -- LR(0) pasing example and SLR(1) table
  { url: "https://www.youtube.com/embed/MIg2ymmMn4k" }, // Compiler Design Lecture 12 -- Examples of LR(0) and SLR(1)
  { url: "https://www.youtube.com/embed/5s4CWn6GiwY" }, // Compiler Design Lecture 13 -- Examples of LR(0) and SLR(1)
  { url: "https://www.youtube.com/embed/VSkfnRfNuwI" }, // Compiler Design Lecture 14 -- CLR(1) and LALR(1) Parsers
  { url: "https://www.youtube.com/embed/Nxj0g1mk5Ak" }, // Compiler Design Lecture 15 -- conflicts and examples of CLR(1) and LALR(1)
  { url: "https://www.youtube.com/embed/1XD2wk52-Cs" }, // Compiler Design Lecture 16 -- Examples of CLR(1) and LALR(1) and comparison of all the parsers
  { url: "https://www.youtube.com/embed/queUceGJqh0" }, // Compiler Design Lecture 17 -- Syntax directed translation examples
  { url: "https://www.youtube.com/embed/fmRgKPLEROg" }, // Compiler Design Lecture 18 -- Examples of SDT
  { url: "https://www.youtube.com/embed/rdnAJBoFKOw" } //  Compiler Design Lecture 19 -- S attributed and L attributed definitions
];

export default function ThirdSemVideo() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpand) => {
    setExpanded(isExpand ? panel : false);
  };

  return (
    <div>
      <Navbar />
      <Link id="back" to="/VideoClass">
        <Button
          style={{ margin: "10px", marginTop: "80px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
  
      <h1 id="desc" style={{ textAlign: "center" }}>
        Third sem CSE/ISE Video Class
      </h1>
      <Divider />
   
      {/* subject divider */}
      <h3>CNS (15CS61 or 17CS61) playlist </h3>

      <div className="scrollmenu" style={{ marginTop: "10px" }}>
        {CNS_main_topic.map(p => (
          <iframe
            title="VideoClassFrame"
            id="ytframe"
            src={p.url}
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            frameBorder="0"
            oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen"
          >
            {" "}
          </iframe>
        ))}
      </div>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography> More CNS contents here</Typography>
          {/* <Typography>  click here</Typography> */}
        </ExpansionPanelSummary>
        <div className="scrollmenu" style={{ marginTop: "10px" }}>
          {CNS_extra_topics.map(p => (
            <iframe
              title="VideoClassFrame"
              id="ytframe"
              src={p.url}
              allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen"
              msallowfullscreen="msallowfullscreen"
              frameBorder="0"
             
              oallowfullscreen="oallowfullscreen"
              webkitallowfullscreen="webkitallowfullscreen"
            >
              {" "}
            </iframe>
          ))}
        </div>
      </ExpansionPanel>
      <Divider />

      {/* subject divider */}
      <h3>CG (17CS62 / 15CS62) playlist </h3>

      <div className="scrollmenu" style={{ marginTop: "10px" }}>
        {CG_main_topic.map(p => (
          <iframe
            title="VideoClassFrame"
            id="ytframe"
            src={p.url}
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            frameBorder="0"
            oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen"
          >
            {" "}
          </iframe>
        ))}
      </div>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography> More CG contents here</Typography>
          {/* <Typography>  click here</Typography> */}
        </ExpansionPanelSummary>
        <div className="scrollmenu" style={{ marginTop: "10px" }}>
          {CG_extra_topics.map(p => (
            <iframe
              title="VideoClassFrame"
              id="ytframe"
              src={p.url}
              allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen"
              msallowfullscreen="msallowfullscreen"
              frameBorder="0"
              oallowfullscreen="oallowfullscreen"
              webkitallowfullscreen="webkitallowfullscreen"
            >
              {" "}
            </iframe>
          ))}
        </div>
      </ExpansionPanel>
      <Divider />

      {/* subject divider */}
      <h3>SS&#38;CD (15CS61 or 17CS61) playlist </h3>

      <div className="scrollmenu" style={{ marginTop: "10px" }}>
        {SsCd_main_topic.map(p => (
          <iframe
            title="VideoClassFrame"
            id="ytframe"
            src={p.url}
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            frameBorder="0"
            oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen"
          >
            {" "}
          </iframe>
        ))}
      </div>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography> More SS&#38;CD contents here</Typography>
          {/* <Typography>  click here</Typography> */}
        </ExpansionPanelSummary>
        <div className="scrollmenu" style={{ marginTop: "10px" }}>
          {SsCd_extra_topics.map(p => (
            <iframe
              title="VideoClassFrame"
              id="ytframe"
              src={p.url}
              allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen"
              msallowfullscreen="msallowfullscreen"
              frameBorder="0"
              oallowfullscreen="oallowfullscreen"
              webkitallowfullscreen="webkitallowfullscreen"
            >
              {" "}
            </iframe>
          ))}
        </div>
      </ExpansionPanel>
      <Divider />

      {/* subject divider */}
      <h3>OR (15CS61 or 17CS61) playlist </h3>

      <div className="scrollmenu" style={{ marginTop: "10px" }}>
        {OR_main_topic.map(p => (
          <iframe
            title="VideoClassFrame"
            id="ytframe"
            src={p.url}
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            frameBorder="0"
            oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen"
          >
            {" "}
          </iframe>
        ))}
      </div>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography> More OR contents here</Typography>
          {/* <Typography>  click here</Typography> */}
        </ExpansionPanelSummary>
        <div className="scrollmenu" style={{ marginTop: "10px" }}>
          {OR_extra_topics.map(p => (
            <iframe
              title="VideoClassFrame"
              id="ytframe"
              src={p.url}
              allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen"
              msallowfullscreen="msallowfullscreen"
              frameBorder="0"
              oallowfullscreen="oallowfullscreen"
              webkitallowfullscreen="webkitallowfullscreen"
            >
              {" "}
            </iframe>
          ))}
        </div>
      </ExpansionPanel>
      <Divider />
    </div>
  );
}
